import { render, staticRenderFns } from "./EsButton.vue?vue&type=template&id=bb5c0996&scoped=true&"
import script from "./EsButton.vue?vue&type=script&lang=js&"
export * from "./EsButton.vue?vue&type=script&lang=js&"
import style0 from "./EsButton.vue?vue&type=style&index=0&id=bb5c0996&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5c0996",
  null
  
)

export default component.exports